import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import { fromJS } from 'immutable';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import messages from './messagesExchangeOrder';

import { formatPrice } from '../../../utils';

import styles from './styles';

const ExchangeOrderTitle = ({
    intl,
    intl: {
        formatMessage,
    },
    classes,
    exchangeableTicketableFareIds,
    orderDetails,
    isSeasonTrip,
    seasonFareDetails,
    ticketableFareGroups,
    showSeatsAndServices,
    selectedSeat,
}) => {
    const immutableTicketableFareGroups = ticketableFareGroups?.length
        ? fromJS(ticketableFareGroups)
        : orderDetails.getIn(['BookingOrders', 0, 'ticketableFareGroups']);

    const selectedTicketableFareGroup = immutableTicketableFareGroups.filter(
        (ticketableFareGroup) => exchangeableTicketableFareIds.includes(ticketableFareGroup.get('BookingDetailsLegTicketableFareIds')),
    );

    return (
        <AppBar position="static" color="default" className={classes.headerSelectedAppBar}>
            <Toolbar variant="dense">
                <table className={classes.table}>
                    <tbody>
                        <tr>
                            <th>
                                <Typography variant="body2" className={classes.headerSelectedLabel}>
                                    <FormattedMessage {...messages.lblPassengers} />
                                </Typography>
                            </th>
                            <th>
                                <Typography variant="caption" className={classes.passengers}>
                                    {selectedTicketableFareGroup
                                        .getIn([0, 'passengers'])
                                        ?.toJS()
                                        .sort((a, b) => (a.passengerId > b.passengerId ? 1 : -1))
                                        .map((passenger) => `${passenger.firstName} ${passenger.lastName}`)
                                        .join(', ')}
                                </Typography>
                            </th>
                        </tr>
                        <tr>
                            <th>
                                <Typography variant="body2" className={classes.headerSelectedLabel}>
                                    <FormattedMessage {...messages.lblExchangedHeader} />
                                </Typography>

                            </th>
                            <th>
                                <Table className={classes.headerTable}>
                                    <TableHead>
                                        <TableRow className={classes.headerSelectedRow}>
                                            <TableCell>
                                                {formatMessage(isSeasonTrip ? messages.lblOrigin : messages.lblDepartStation)}
                                            </TableCell>
                                            <TableCell>
                                                {formatMessage(isSeasonTrip ? messages.lblDestination : messages.lblDepartDate)}
                                            </TableCell>
                                            <TableCell>
                                                {formatMessage(isSeasonTrip ? messages.lblSeasonStartDate : messages.lblArriveStation)}
                                            </TableCell>
                                            <TableCell>
                                                {formatMessage(isSeasonTrip ? messages.lblSeasonEndDate : messages.lblArriveDate)}
                                            </TableCell>
                                            <TableCell>
                                                <FormattedMessage {...messages.lblPrice} />
                                            </TableCell>
                                            {showSeatsAndServices && (
                                                <>
                                                    <TableCell>
                                                        Seats
                                                    </TableCell>
                                                    <TableCell>
                                                        Amenities & Services
                                                    </TableCell>
                                                </>
                                            )}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {selectedTicketableFareGroup.map((selectedFare) => (
                                            <TableRow
                                                key={selectedFare.get('BookingDetailsLegTicketableFareIds')}
                                                className={classes.headerSelectedRow}
                                            >
                                                <TableCell>{isSeasonTrip ? seasonFareDetails.get('departStationName') : selectedFare.get('departStationLongName')}</TableCell>
                                                <TableCell>{isSeasonTrip ? seasonFareDetails.get('arriveStationName') : selectedFare.get('departDate')}</TableCell>
                                                <TableCell>{isSeasonTrip ? seasonFareDetails.get('startDate') : selectedFare.get('arriveStationLongName')}</TableCell>
                                                <TableCell>{isSeasonTrip ? seasonFareDetails.get('endDate') : selectedFare.get('arriveDate')}</TableCell>
                                                <TableCell>
                                                    {formatPrice(
                                                        selectedFare.get('ticketableFarePrice'),
                                                        selectedFare.get('ticketableFareCurrency'),
                                                        intl,
                                                    )}
                                                </TableCell>
                                                {showSeatsAndServices && (
                                                    <>
                                                        <TableCell>
                                                            {selectedSeat ? selectedSeat : selectedFare.get('BookingLegTravelSegments').toJS()[0].BookingLegTravelSegmentSeats}
                                                        </TableCell>
                                                        <TableCell>
                                                            {selectedFare.get('BookingLegTravelSegments').toJS()[0].BookingOrderServicesAndAmenities.map(
                                                                (item) => <span>{item.BookingOrderServicesAndAmenitiesDesc} <br /></span>
                                                            )}
                                                        </TableCell>
                                                    </>
                                                )}
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </Toolbar>
        </AppBar>
    );
};

ExchangeOrderTitle.propTypes = {
    intl: PropTypes.object,
    classes: PropTypes.object,
    exchangeableTicketableFareIds: PropTypes.array,
    orderDetails: PropTypes.object,
    isSeasonTrip: PropTypes.bool,
    seasonFareDetails: PropTypes.object,
    ticketableFareGroups: PropTypes.array,
    showSeatsAndServices: PropTypes.bool,
    selectedSeat: PropTypes.string,
};

export { ExchangeOrderTitle as ExchangeOrderTitleAlias };

export default injectIntl(withStyles(styles)(ExchangeOrderTitle));
